import { verifySSOToken } from '../api/authentication';

export async function processSSOResponse(response, store, dispatch, setRedirecting) {
  if (response.account) {
    store.ssoUserDetails[1]({
      name: response.account.name,
      username: response.account.username,
    });
  }

  const data = await verifySSOToken(response.idToken);

  if (data.token) {
    sessionStorage.setItem('token', data.token);
    sessionStorage.setItem('company', data.company);
    sessionStorage.setItem('companyid', data.companyid);
    sessionStorage.setItem('name', data.name);
    sessionStorage.setItem('reg', data.reg);
    sessionStorage.setItem('type', data.type);
    sessionStorage.setItem('fullName', data.fullName);
    sessionStorage.setItem('role', data.role);
    sessionStorage.setItem('department', data.department);
    sessionStorage.setItem('admin', data.admin);
    sessionStorage.setItem('trader', data.trader);
    sessionStorage.setItem('lsp', data.lsp);
    sessionStorage.setItem('lsp', data.wlp);
    sessionStorage.setItem('lastLoggedIn', data.lastLoginIn);
    sessionStorage.setItem('sso', 1);

    dispatch({ type: 'login', detail: data });
    setRedirecting(true);
  }

  if (data.error === 'Invalid user' || data.err === 'Invalid user') {
    // redirect user to the ICS2 sign-up page
    store.isSSOUserWithNoCompany[1](true);
    const ics2Url = process.env.REACT_APP_ICS2_FRONTEND_URL || 'http://localhost:82/';
    window.location.href = ics2Url + 'register?sso=1';
  } else {
    store.isSSOUserWithNoCompany[1](false);
  }
}

export const SSOLoginPopupWrapper = async (instance, request) => {
  try {
    const response = await instance.loginPopup(request);
    return response;
  } catch (e) {
    return { error: true, errorCode: e.errorCode };
  }
};
